export default __webpack_public_path__ + "static/media/3.632e0107.jpg";